var map = {
  "./cs.messages.tsx": [
    "58749",
    [
      53097
    ]
  ],
  "./en.messages.tsx": [
    "7820",
    [
      24178
    ]
  ],
  "./sl.messages.tsx": [
    "59040",
    [
      88010
    ]
  ],
  "./hu.messages.tsx": [
    "22956",
    [
      25942
    ]
  ],
  "./de.messages.tsx": [
    "20328",
    [
      1706
    ]
  ],
  "./it.messages.tsx": [
    "82870",
    [
      80040
    ]
  ],
  "./pl.messages.tsx": [
    "14807",
    [
      9031
    ]
  ],
  "./fr.messages.tsx": [
    "52155",
    [
      17039
    ]
  ],
  "./sk.messages.tsx": [
    "81285",
    [
      90385
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 67229;
module.exports = __rspack_async_context;
